/* ============================================================
   PSI v213 — Pulsante "Indietro" sulle pagine legali.

   PERCHE' IN JAVASCRIPT
   Le pagine /policies/* non passano dai template del tema (vedi la nota in
   templates/policy.liquid): il markup lo genera Shopify e non e' modificabile.
   L'unico modo per aggiungerci un elemento e' inserirlo dal browser.

   COSA FA, e perche' non e' un semplice history.back()
   Il cliente arriva su queste pagine da tre strade diverse:
   1. da un link del sito (footer, spunta privacy della newsletter) — in questo
      caso deve tornare esattamente da dove veniva: history.back() conserva la
      posizione nello scroll e, sulla scheda prodotto, la variante scelta.
      Un link fisso alla home la perderebbe.
   2. da Google o da un link esterno — qui history.back() lo porterebbe FUORI
      dal sito, cioe' lo farebbe uscire dal negozio. Si va in home.
   3. aperta in una scheda nuova (referrer vuoto, history lunga 1) — stesso
      caso del punto 2.

   Il controllo e' sull'origine del referrer, non sulla sua semplice presenza:
   un referrer di un altro sito e' il caso 2, non il caso 1.

   Lo stile sta in assets/psi-policy.css (.psi-policy-back).
   ============================================================ */
(function () {
  'use strict';

  var container = document.querySelector('.shopify-policy__container');
  if (!container || document.querySelector('.psi-policy-back')) return;

  var titolo = container.querySelector('.shopify-policy__title');
  if (!titolo) return;

  /* Si torna indietro solo se la pagina precedente e' di questo stesso sito. */
  var interno = false;
  try {
    interno = !!document.referrer &&
              new URL(document.referrer).origin === window.location.origin &&
              window.history.length > 1;
  } catch (e) {
    interno = false;
  }

  var back = document.createElement('a');
  back.className = 'psi-policy-back';
  back.href = interno ? document.referrer : '/';
  back.innerHTML = '<span class="psi-policy-back-arrow" aria-hidden="true">←</span>' +
                   '<span>' + (interno ? 'Indietro' : 'Torna al negozio') + '</span>';

  if (interno) {
    /* href valorizzato lo stesso: cosi' funziona il clic col tasto centrale,
       "apri in nuova scheda" e la lettura da parte dei lettori di schermo.
       Il clic normale invece usa la cronologia, che riporta anche allo scroll. */
    back.addEventListener('click', function (ev) {
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
      ev.preventDefault();
      window.history.back();
    });
  }

  titolo.insertBefore(back, titolo.firstChild);
})();
